module.exports = __webpack_public_path__ + "img/icon-pro.839bffbb.svg";